// Module
var code = "<a href=\"javascript:;\" class=\"btn blue-dark subFormControl special-btn\"> <i class=\"fa fa-slideshare\"></i><span data-bind=\"text: _labels.SPECIAL\"></span> </a>";
// Exports
export default code;